import { SparkBadge } from 'types/common/SparkBadge';

export const getGropedSparkBadges = (badges: SparkBadge[] | undefined) => {
  if (!badges) {
    return;
  }
  return badges.reduce<Record<string, SparkBadge[]>>((acc, curr) => {
    if (acc[curr.type]) {
      return { ...acc, [curr.type]: [...acc[curr.type], curr] };
    }

    return { ...acc, [curr.type]: [curr] };
  }, {});
};
